export const FILM_IMAGE_REQUEST = "FILM_IMAGE_REQUEST";
export const FILM_IMAGE_SUCCESS = "FILM_IMAGE_SUCCESS";
export const FILM_IMAGE_FAIL = "FILM_IMAGE_FAIL";

export const FILM_BACKIMAGE_REQUEST = "FILM_BACKIMAGE_REQUEST";
export const FILM_BACKIMAGE_SUCCESS = "FILM_BACKIMAGE_SUCCESS";
export const FILM_BACKIMAGE_FAIL = "FILM_BACKIMAGE_FAIL";